// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"style_pageContainer__rT56f","content":"style_content__DjR_u","sidebar":"style_sidebar__Nj00q","breadcrumb":"style_breadcrumb__Bkyhf"};